import type { ReactNode } from 'react';
import { SlidersHorizontal } from 'lucide-react';
import { Popover, PopoverContent, PopoverTrigger } from '@/components/ui/popover';
import { SETTINGS_HEADER_BUTTON_CLASS } from './settings-ui';

/** The header's "Filters" button; the filter controls open under it, one per row. */
export function FiltersPopover({ activeCount, children }: { activeCount: number; children: ReactNode }) {
	return (
		<Popover>
			<PopoverTrigger asChild>
				<button type='button' className={SETTINGS_HEADER_BUTTON_CLASS}>
					<SlidersHorizontal className='size-3.5' />
					Filters
					{activeCount > 0 && (
						<span className='flex size-4 items-center justify-center rounded-full bg-ink text-[10px] font-medium text-white'>{activeCount}</span>
					)}
				</button>
			</PopoverTrigger>
			<PopoverContent align='end' className='flex w-[320px] flex-col gap-4 rounded-2xl border border-gray-300 bg-white p-4 shadow-[0px_3px_12px_0px_rgba(0,0,0,0.08)]'>
				{children}
			</PopoverContent>
		</Popover>
	);
}

/** One labelled filter inside the popover. */
export function FilterField({ label, children }: { label: string; children: ReactNode }) {
	return (
		<div className='flex flex-col gap-2'>
			<p className='text-[12px] font-medium leading-4 text-gray-900'>{label}</p>
			{children}
		</div>
	);
}
